module.exports = __webpack_public_path__ + "static/img/logo-copy.ca1a8a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-copy.png
// module id = cFw6
// module chunks = 1 2 3 4 5 6 7